import { Route } from "found";


import AdminMenuPage from "./AdminMenuPage";
import AdminMenuQuery from "./AdminMenuQuery";
import AiSettingsPage from "./AiSettingsPage";
import AiSettingsQuery from "./AiSettingsQuery";

import { PageWrapper } from "pstat-anywhere/utils/pageWrappers";

const routes = (
  <Route path="admin">
    <Route
      path=""
      query={AdminMenuQuery}
      data={{
        routeName: "admin_menu"
      }}
      render={({ props }) => {
        return (
          <PageWrapper
            component={AdminMenuPage}
            queryName="adminMenu"
            titleKey="administration.title"
            {...props}
          />
        );
      }}
    />
    <Route
      path="ai_settings"
      query={AiSettingsQuery}
      data={{
        routeName: "ai_settings"
      }}
      render={({ props }) => {
        return (
          <PageWrapper
            component={AiSettingsPage}
            titleKey="administration.configuration.aiSettings"
            {...props}
          />
        );
      }}
    />
  </Route>
);

export default routes;
